import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { IncidentsTable } from 'interfaces/incidents.interface.ts';

const BaseURL = 'https://st3jlq3ovc.execute-api.us-east-1.amazonaws.com/prod';

interface AuthGroupParams {
  token: string;
  groupID: number;
}

export const incidentApi = createApi({
  reducerPath: 'incidentsApi',
  baseQuery: fetchBaseQuery({
    baseUrl: BaseURL,
  }),
  endpoints: (builder) => ({
    allIncidents: builder.query<{ dataset: IncidentsTable[]; count: number }, AuthGroupParams>({
      query: ({ token, groupID }) => ({
        url: '/api/incidents',
        params: {
          access_token: token,
          groupID,
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }),
    }),
  }),
});

export const { useLazyAllIncidentsQuery } = incidentApi;
